import {HeroTitle} from "@/pages/common/Home/components/HeroTitle";

import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const Intro = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.intro}>
      <HeroTitle>
        <span>
          <strong>{t("page.effectiveness.intro_title")}</strong>
        </span>

        <span>{t("page.effectiveness.intro_desc")}</span>
      </HeroTitle>
    </div>
  );
};
